var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attentionds" }, [
    _c(
      "div",
      { staticClass: "attentiondsTit" },
      [
        _c("div", { staticClass: "attentionBox" }, [
          _c("div", {}, [
            _c("div", { staticClass: "searchRight" }, [
              !_vm.edit
                ? _c(
                    "span",
                    { staticClass: "batch", on: { click: _vm.showEdit } },
                    [_vm._v("批量管理")]
                  )
                : _c(
                    "div",
                    { staticClass: "saveList" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          on: { change: _vm.changeChecked },
                          model: {
                            value: _vm.selectAll,
                            callback: function($$v) {
                              _vm.selectAll = $$v
                            },
                            expression: "selectAll"
                          }
                        },
                        [_vm._v("全选")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "delete", on: { click: _vm.cancelFun } },
                        [_vm._v("取消收藏")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "save", on: { click: _vm.saveList } },
                        [_vm._v("完成")]
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.activeName === "commodity"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyword,
                        expression: "keyword"
                      }
                    ],
                    attrs: { type: "text", placeholder: "请输入搜索商品" },
                    domProps: { value: _vm.keyword },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchPro.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.keyword = $event.target.value
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyword,
                        expression: "keyword"
                      }
                    ],
                    attrs: { type: "text", placeholder: "请输入搜索店铺" },
                    domProps: { value: _vm.keyword },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchPro.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.keyword = $event.target.value
                      }
                    }
                  }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "searchBtn", on: { click: _vm.searchPro } },
                [_vm._v("搜索")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "收藏的商品", name: "commodity" } },
              [
                _vm.flag
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "list sub-main"
                      },
                      [
                        _c("div", { staticClass: "attentiondsList" }, [
                          _c(
                            "div",
                            { staticClass: "listBox" },
                            [
                              _vm._l(_vm.attentiondList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: item.collectId,
                                    staticClass: "attentiondsItem",
                                    class: {
                                      selected: item.selected === 1,
                                      edit: _vm.edit
                                    },
                                    on: {
                                      mouseover: function($event) {
                                        return _vm.changeShowDel(item, true)
                                      },
                                      mouseleave: function($event) {
                                        return _vm.changeShowDel(item, false)
                                      },
                                      click: function($event) {
                                        return _vm.selectPro(
                                          index,
                                          item.selected
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.edit
                                      ? _c("div", { staticClass: "mc" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.showDel && !_vm.edit
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "delete-box",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.cancelSingle(
                                                  item.collectId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "icon-shanchu"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "imgBox",
                                        class: {
                                          offShelf:
                                            item.shelveState === 0 ||
                                            (item.showDel && !_vm.edit)
                                        },
                                        on: {
                                          click: function($event) {
                                            !_vm.edit &&
                                              _vm.toProductDetail(item)
                                          }
                                        }
                                      },
                                      [
                                        item.shelveState === 0
                                          ? _c(
                                              "div",
                                              { staticClass: "tipText" },
                                              [_c("span", [_vm._v("已下架")])]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.showDel &&
                                        !_vm.edit &&
                                        item.shelveState !== 0
                                          ? _c("div", {
                                              staticClass: "tipText"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: { src: item.image, alt: "" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "info",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            !_vm.edit &&
                                              _vm.toProductDetail(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "flex-start",
                                              "align-items": "center",
                                              "margin-bottom": "10px"
                                            }
                                          },
                                          [
                                            item.category == 0
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      color: "#fff",
                                                      "font-size": "12px",
                                                      "border-color": "#409eff"
                                                    },
                                                    attrs: {
                                                      effect: "dark",
                                                      color: "#409EFF",
                                                      size: "mini"
                                                    }
                                                  },
                                                  [_vm._v("零售")]
                                                )
                                              : item.category == 1
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      color: "#fff",
                                                      "font-size": "12px"
                                                    },
                                                    attrs: {
                                                      effect: "dark",
                                                      color: "#FF7800",
                                                      size: "mini"
                                                    }
                                                  },
                                                  [_vm._v("大宗")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass: "overflow",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  "margin-top": "0"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.productName) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "price",
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                              "align-item": "center"
                                            }
                                          },
                                          [
                                            _c("span", [_vm._v("¥")]),
                                            _vm._v(_vm._s(item.price))
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm.attentiondList.length > 0
                          ? _c("el-pagination", {
                              attrs: {
                                background: "",
                                layout: "prev, pager, next, jumper",
                                "page-size": 10,
                                "current-page": _vm.page,
                                total: _vm.total
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "nothing sub-main" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../../static/image/nothing@2x.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "fs20 font-color-999" }, [
                          _vm._v("您还没有收藏的商品～")
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/" } },
                          [_c("el-button", [_vm._v("去首页看看")])],
                          1
                        )
                      ],
                      1
                    )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              { attrs: { label: "收藏的店铺", name: "shop" } },
              [
                _vm.flag1
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "list sub-main"
                      },
                      [
                        _c("div", { staticClass: "attentiondsList" }, [
                          _c(
                            "div",
                            { staticClass: "listBox" },
                            [
                              _vm._l(_vm.shopList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: item.id,
                                    staticClass: "attentiondsItem",
                                    class: {
                                      selected: item.selected === 1,
                                      edit: _vm.edit
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectShop(
                                          index,
                                          item.selected
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.edit
                                      ? _c("div", { staticClass: "mc" })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "imgBox" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/images/noStore.png"),
                                          alt: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toStore(item.shopId)
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info" }, [
                                      _c("h3", [_vm._v(_vm._s(item.shopName))])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "btnBox" }, [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.cancelSingle(
                                                item.collectId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("取消收藏")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.toStore(item.shopId)
                                            }
                                          }
                                        },
                                        [_vm._v("进入店铺")]
                                      )
                                    ])
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm.shopList.length > 0
                          ? _c("el-pagination", {
                              attrs: {
                                background: "",
                                layout: "prev, pager, next, jumper",
                                "page-size": 10,
                                "current-page": _vm.page,
                                total: _vm.total
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "nothing sub-main" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../../static/image/nothing@2x.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "fs20 font-color-999" }, [
                          _vm._v("您还没有收藏的店铺～")
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/" } },
                          [_c("el-button", [_vm._v("去首页看看")])],
                          1
                        )
                      ],
                      1
                    )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3fdcdcaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3fdcdcaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/favorites/favorites.vue
// module id = null
// module chunks = 